export interface Inquiry {
  id: string;
  name: string;
  email: string;
  phone: string;
  company: string;
  service: string;
  message: string;
  date: string;
  status: 'new' | 'read' | 'replied';
  reply?: string;
  replyDate?: string;
}

export const sampleInquiries: Inquiry[] = [
  {
    id: 'inq-001',
    name: 'Michael Torres',
    email: 'michael.torres@techcorp.com',
    phone: '(323) 555-0192',
    company: 'TechCorp Solutions',
    service: 'Hard Drive Shredding',
    message: 'We have approximately 200 hard drives from our office refresh project. We need a certificate of destruction for HIPAA compliance. Can you provide on-site shredding at our Burbank location?',
    date: '2026-04-01T09:23:00',
    status: 'new',
  },
  {
    id: 'inq-002',
    name: 'Sarah Kim',
    email: 's.kim@lamedical.org',
    phone: '(310) 555-0847',
    company: 'LA Medical Center',
    service: 'Data Destruction',
    message: 'Our IT department is upgrading 150 workstations. We require DoD-compliant data wiping and documentation for HIPAA. Please send pricing for bulk data destruction.',
    date: '2026-03-31T14:10:00',
    status: 'read',
  },
  {
    id: 'inq-003',
    name: 'David Nguyen',
    email: 'dnguyen@gmail.com',
    phone: '(818) 555-0334',
    company: '',
    service: 'Electronics Recycling',
    message: 'Hi, I have an old desktop computer, 2 monitors, a printer, and lots of cables I need to drop off. Do I need an appointment or can I just walk in?',
    date: '2026-03-30T11:05:00',
    status: 'replied',
    reply: 'Hi David! No appointment needed for drop-offs. We are open Mon-Fri 8am-5pm and Sat 9am-2pm at 2542 W. 3rd Street, Los Angeles. See you soon!',
    replyDate: '2026-03-30T13:30:00',
  },
  {
    id: 'inq-004',
    name: 'Jennifer Walsh',
    email: 'j.walsh@cityofla.gov',
    phone: '(213) 555-0561',
    company: 'City of Los Angeles',
    service: 'E-Waste Pickup',
    message: 'The City of LA Parks Department is looking for a recurring quarterly e-waste pickup program for 12 park facilities across the city. Please send information on your corporate programs.',
    date: '2026-03-29T10:45:00',
    status: 'replied',
    reply: 'Hello Jennifer, thank you for reaching out on behalf of the City of LA! We would love to discuss a customized quarterly program. I will have our corporate accounts manager call you this week. Best regards, Greenly Team',
    replyDate: '2026-03-29T15:00:00',
  },
  {
    id: 'inq-005',
    name: 'Carlos Reyes',
    email: 'creyes@reyes-law.com',
    phone: '(323) 555-0720',
    company: 'Reyes & Associates Law',
    service: 'Hard Drive Shredding',
    message: 'Our law firm needs to dispose of 35 hard drives and several boxes of backup tapes. Everything must be witnessed and documented for client confidentiality. Do you offer witnessed destruction?',
    date: '2026-03-28T16:20:00',
    status: 'new',
  },
];
